var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-pt-batch-monitoring-table',{ref:"table",staticClass:"pt-pt-batch-monitoring-table__withData",attrs:{"tableLabels":_vm.tableLabels,"totalNumber":_vm.totalNumber,"tableData":_vm.tableData},on:{"getTableData":_vm.getTableData}})}
var staticRenderFns = []

export { render, staticRenderFns }